<!-- <app-nav-bar *ngIf="this.authService.isAuthenticatedUser()"></app-nav-bar>

<app-Login *ngIf="!this.authService.isAuthenticatedUser()"></app-Login> -->
<app-nav-bar></app-nav-bar>